<span
  #dropdownTrigger="rtOverlayOrigin"
  rt-overlay-origin
  [rtWalkthroughOriginStepId]="'walkthrough-step-proceed-disqualify-4'"
  [rtWalkthroughOriginBeforeRender]="beforeWalkthroughTooltipRender | fnBind: this"
>
  <ng-template
    [ngTemplateOutlet]="triggerTpl()"
    [ngTemplateOutletContext]="{ isOpen: isOpen, toggle: toggle }"
  />
</span>

<ng-template
  #overlay="rtConnectedOverlay"
  rt-connected-overlay
  [origin]="dropdownTrigger"
  [open]="isOpen"
  [width]="300"
  [positions]="customDropdownPositions ? customDropdownPositions : dropdownPositions"
  [hasBackdrop]="true"
  [isPinned]="false"
  [withPush]="withPush()"
  (backdropClick)="toggle(false)"
>
  <rt-dropdown>
    <rt-disqualify-reasons-dropdown-template
      [collection]="collection()"
      [origin]="dropdownTrigger"
      [overlay]="overlay"
      [hasClear]="hasClear()"
      [hasEditOption]="hasEditOption()"
      (select)="select.emit($event); toggle(false)"
      (edit)="edit.emit($event); toggle(false)"
      (clear)="clear.emit($event); toggle(false)"
      (actionsDetails)="actionsDetails.emit($event)"
      (click)="$event.stopPropagation()"
    />
  </rt-dropdown>
</ng-template>
